import { formatDateToDDMMYYYY } from '../../helper';
import { DispatchListDetailsRes, Docs } from '@zonofi/zono-money-store';

export const convertDispatchDetailsToFormdata = (
  data: DispatchListDetailsRes
): Record<string, string | string[]> => {
  const result: Record<string, string | string[]> = {};

  Object.entries(data).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (key === 'dispatchDate') {
      result[key] = formatDateToDDMMYYYY(value);
    }
    if (key === 'dispatchDocNumber' || key === 'dispatchDocNo') {
      result['dispatchDocNo'] = value;
    }
    if (key === 'totalWeightINKg' && typeof value === 'number' && value > 0) {
      result['totalWeight'] = String(value);
    }
    if (key === 'numOfBoxes' && typeof value === 'number' && value > 0) {
      result['totalBox'] = String(value);
    }
    if (key === 'destinationAddress') {
      result['address'] = value;
    }
    if (key === 'destinationCity') {
      result['cityName'] = value;
    }
    if (key === 'destinationZipCode') {
      result['Pincode'] = value;
    }

    if (key === 'docs') {
      const docsArray = value as Docs[];

      const urls = docsArray
        ?.map((doc) => doc?.url)
        .filter((url): url is string => Boolean(url));

      if (urls?.length) {
        result[key] = urls;
      }
      return;
    }

    if (Array.isArray(value)) {
      result[key] = value.every((v) => typeof v === 'string')
        ? value
        : value.map((v) => JSON.stringify(v));
    } else if (typeof value === 'object') {
      result[key] = JSON.stringify(value);
    } else {
      result[key] = String(value);
    }
  });

  return result;
};
